import styled from 'styled-components';

export const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 100vh;
`;

export const Content = styled.main`
  flex-grow: 1;
  overflow-y: auto;
  padding-top: 52px;
`;

export const MainContent = styled.div<{ $collapsed: boolean }>`
  padding: ${props => (props.$collapsed ? '30px 30px 30px 50px' : '30px 30px 30px 300px')};
  transition: padding 0.2s;
`;
